package music.jammers.client.shared.auth.domain.model

class LoginException(val code: Long, message: String?) : IllegalStateException(message)